import React from "react";
import { createUseStyles } from "react-jss";

const useStyles = createUseStyles((theme) => ({
	root: {
		position: "relative",
		width: "317px",
	},
	shortDescription: {
		marginTop: "8px",
		fontSize: "16px",
		color: theme.palette.colors.darkSlateBlue,
	},
	logo: {
		display: "none",
	},
	benefitsList: {
		marginTop: "12px",
	},
	dodyList: {
		marginTop: "10px",
	},
	[`@media (min-width: ${theme.media.md}) and (max-width: ${theme.media.lg})`]: {
		root: {
			width: "238px",
		},
	},
	[`@media (min-width: ${theme.media.sm}) and (max-width: ${theme.media.md})`]: {
		root: {
			width: "150px",
		},
		shortDescription: {
			fontSize: "14px",
		},
	},
	[`@media (max-width: ${theme.media.sm})`]: {
		root: {
			width: "100%",
		},
		logo: {
			display: "block",
		},
		tariffName: {
			maxWidth: "100%",
			minWidth: "160px",
		},
	},
}));

const TariffInfo = ({
	tariffName,
	shortDescription,
	logoComponent,
	linkComponent,
	generateProviderRates,
	tariff,
	benefitsList,
	dodyList,
}) => {
	const classes = useStyles();

	const preventPropagation = (e) => {
		e.stopPropagation();
	};

	return (
		<div className={classes.root}>
			{!!logoComponent &&
				React.cloneElement(linkComponent, {
					onClick: preventPropagation,
					to: generateProviderRates(tariff),
					className: classes.logo,
					children: logoComponent,
				})}
			{tariffName}
			{!!shortDescription && <div className={classes.shortDescription}>{shortDescription}</div>}
			{benefitsList && <div className={classes.benefitsList}>{benefitsList}</div>}
			{dodyList && <div className={classes.dodyList}>{dodyList}</div>}
		</div>
	);
};

export default TariffInfo;
